import { render, staticRenderFns } from "./AdvertsForm.vue?vue&type=template&id=44c8ad74&scoped=true&"
import script from "./AdvertsForm.vue?vue&type=script&lang=js&"
export * from "./AdvertsForm.vue?vue&type=script&lang=js&"
import style0 from "./AdvertsForm.vue?vue&type=style&index=0&id=44c8ad74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c8ad74",
  null
  
)

export default component.exports